module.exports = "<div lm-sidebar></div>\n<div lm-forcechart></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/directives/lateralmap/view.html
 ** module id = 818
 ** module chunks = 0
 **/